import React, { useState, useEffect } from "react";
import { db, storage } from "../firebase";
import {
    collection, addDoc, onSnapshot, query,
    orderBy, serverTimestamp, where, getDocs
} from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

// =====================
// PULA ZADAŃ
// =====================
const TASKS = [
    // 🟢 ŁATWE (1 pkt)
    { id: 1, text: "Zrób selfie z parą młodą 💑", level: "easy", points: 1, emoji: "📸" },
    { id: 2, text: "Zatańcz z kimś kogo nie znasz 💃", level: "easy", points: 1, emoji: "💃" },
    { id: 3, text: "Wznieś toast za parę młodą 🥂", level: "easy", points: 1, emoji: "🥂" },
    { id: 4, text: "Napisz życzenie w księdze gości ✍️", level: "easy", points: 1, emoji: "✍️" },
    { id: 5, text: "Zrób zdjęcie tortu weselnego 🎂", level: "easy", points: 1, emoji: "🎂" },
    { id: 6, text: "Powiedz komplement 3 osobom 💛", level: "easy", points: 1, emoji: "💛" },
    { id: 7, text: "Zrób zdjęcie z kelnerem/kelnerką 🍽️", level: "easy", points: 1, emoji: "🍽️" },
    { id: 8, text: "Znajdź kogoś w tym samym kolorze ubrania 👗", level: "easy", points: 1, emoji: "👗" },
    { id: 9, text: "Zamów drink którego nigdy nie piłeś 🍹", level: "easy", points: 1, emoji: "🍹" },
    { id: 10, text: "Zrób zdjęcie dekoracji weselnych 🌸", level: "easy", points: 1, emoji: "🌸" },
    { id: 11, text: "Porozmawiaj z kimś kogo nie znasz przez 2 minuty 🗣️", level: "easy", points: 1, emoji: "🗣️" },
    { id: 12, text: "Zrób zdjęcie z babcią lub dziadkiem 👴", level: "easy", points: 1, emoji: "👴" },
    { id: 13, text: "Sfotografuj widok z okna 🌅", level: "easy", points: 1, emoji: "🌅" },
    { id: 14, text: "Zrób zdjęcie stołu weselnego 🌷", level: "easy", points: 1, emoji: "🌷" },
    { id: 15, text: "Znajdź najstarszą osobę na weselu i zapytaj o sekret szczęścia 💍", level: "easy", points: 1, emoji: "💍" },
    { id: 16, text: "Zrób selfie z drużbą lub druhną 👔", level: "easy", points: 1, emoji: "👔" },
    { id: 17, text: "Zrób zdjęcie butów pary młodej 👠", level: "easy", points: 1, emoji: "👠" },
    { id: 18, text: "Znajdź kogoś z tym samym imieniem co Ty 🔤", level: "easy", points: 1, emoji: "🔤" },
    { id: 19, text: "Nagraj 10 sekund parkietu podczas tańca 🎵", level: "easy", points: 1, emoji: "🎵" },
    { id: 20, text: "Zrób zdjęcie bukietu ślubnego 💐", level: "easy", points: 1, emoji: "💐" },

    // 🟡 ŚREDNIE (2 pkt)
    { id: 21, text: "Namów 5 osób do wspólnego zdjęcia 📷", level: "medium", points: 2, emoji: "📷" },
    { id: 22, text: "Zatańcz solo na parkiecie przez 1 minutę 🕺", level: "medium", points: 2, emoji: "🕺" },
    { id: 23, text: "Nagraj życzenia wideo dla pary młodej 🎥", level: "medium", points: 2, emoji: "🎥" },
    { id: 24, text: "Zorganizuj grupowe zdjęcie minimum 10 osób 👨‍👩‍👧‍👦", level: "medium", points: 2, emoji: "👨‍👩‍👧‍👦" },
    { id: 25, text: "Naucz kogoś nowego tańca 💃", level: "medium", points: 2, emoji: "💃" },
    { id: 26, text: "Zrób zdjęcie z każdym stolnikiem przy Twoim stole 🪑", level: "medium", points: 2, emoji: "🪑" },
    { id: 27, text: "Opowiedz żart który rozśmieszy minimum 3 osoby 😂", level: "medium", points: 2, emoji: "😂" },
    { id: 28, text: "Zrób zdjęcie z osobą w najciekawszej stylizacji 👑", level: "medium", points: 2, emoji: "👑" },
    { id: 29, text: "Znajdź parę która jest razem najdłużej i zrób z nimi zdjęcie ❤️", level: "medium", points: 2, emoji: "❤️" },
    { id: 30, text: "Stwórz ludzki łańcuch z minimum 8 osób 🔗", level: "medium", points: 2, emoji: "🔗" },
    { id: 31, text: "Zaśpiewaj refren ulubionej piosenki 🎤", level: "medium", points: 2, emoji: "🎤" },
    { id: 32, text: "Zrób zdjęcie z DJ-em lub muzykami 🎧", level: "medium", points: 2, emoji: "🎧" },
    { id: 33, text: "Zorganizuj mini konkurs tańca 🏆", level: "medium", points: 2, emoji: "🏆" },
    { id: 34, text: "Nagraj filmik jak ktoś je tort 🎂", level: "medium", points: 2, emoji: "🎂" },
    { id: 35, text: "Zrób zdjęcie wszystkim drużbom razem 🤵", level: "medium", points: 2, emoji: "🤵" },
    { id: 36, text: "Znajdź osobę która przejechała najdalej na wesele 🚗", level: "medium", points: 2, emoji: "🚗" },
    { id: 37, text: "Namów parę młodą do selfie z językiem 😜", level: "medium", points: 2, emoji: "😜" },
    { id: 38, text: "Zorganizuj zdjęcie z fotobudką 📸", level: "medium", points: 2, emoji: "📸" },
    { id: 39, text: "Znajdź 3 pary i sfotografuj je razem 👫", level: "medium", points: 2, emoji: "👫" },
    { id: 40, text: "Nagraj filmik z okrzykiem na cześć pary młodej 🎉", level: "medium", points: 2, emoji: "🎉" },

    // 🔴 TRUDNE (3 pkt)
    { id: 41, text: "Zatańcz z parą młodą przez całą piosenkę 💑", level: "hard", points: 3, emoji: "💑" },
    { id: 42, text: "Wygłoś spontaniczny toast przed wszystkimi gośćmi 🎤", level: "hard", points: 3, emoji: "🎤" },
    { id: 43, text: "Zorganizuj grupowe zdjęcie minimum 30 osób 📸", level: "hard", points: 3, emoji: "📸" },
    { id: 44, text: "Namów wszystkich przy stole do zaśpiewania refrenu 🎵", level: "hard", points: 3, emoji: "🎵" },
    { id: 45, text: "Zrób zdjęcie z każdym członkiem rodziny pary młodej 👨‍👩‍👧", level: "hard", points: 3, emoji: "👨‍👩‍👧" },
    { id: 46, text: "Zorganizuj flash mob na parkiecie 💃", level: "hard", points: 3, emoji: "💃" },
    { id: 47, text: "Nagraj wywiad z parą młodą 🎥", level: "hard", points: 3, emoji: "🎥" },
    { id: 48, text: "Zbierz podpisy od minimum 20 gości na serwetce 📝", level: "hard", points: 3, emoji: "📝" },
    { id: 49, text: "Zrób zdjęcie z całym personelem obsługi 🍽️", level: "hard", points: 3, emoji: "🍽️" },
    { id: 50, text: "Namów 10 osób do wspólnego okrzyku 📣", level: "hard", points: 3, emoji: "📣" },
    { id: 51, text: "Zorganizuj konkurs na najśmieszniejszą minę 😜", level: "hard", points: 3, emoji: "😜" },
    { id: 52, text: "Stwórz ludzką piramidę z minimum 6 osób 🏋️", level: "hard", points: 3, emoji: "🏋️" },
    { id: 53, text: "Nagraj filmik gdzie wszyscy przy Twoim stole machają do kamery 👋", level: "hard", points: 3, emoji: "👋" },
    { id: 54, text: "Zorganizuj grupowe selfie na parkiecie podczas tańca 💃", level: "hard", points: 3, emoji: "💃" },
    { id: 55, text: "Znajdź i sfotografuj wszystkich singli na weselu 💘", level: "hard", points: 3, emoji: "💘" },
    { id: 56, text: "Namów parę młodą do powtórzenia pierwszego tańca 💑", level: "hard", points: 3, emoji: "💑" },
    { id: 57, text: "Zorganizuj mini karaoke z 5 osobami 🎤", level: "hard", points: 3, emoji: "🎤" },
    { id: 58, text: "Zbierz życzenia od minimum 10 osób na filmiku 🎥", level: "hard", points: 3, emoji: "🎥" },
    { id: 59, text: "Zrób zdjęcie które najlepiej oddaje atmosferę wesela 🌟", level: "hard", points: 3, emoji: "🌟" },
    { id: 60, text: "Namów wszystkich gości do wspólnego tańca w kole 💃", level: "hard", points: 3, emoji: "💃" },
    { id: 61, text: "Stwórz film z najlepszych momentów wesela 🎬", level: "hard", points: 3, emoji: "🎬" },
    { id: 62, text: "Zorganizuj konkurs na najlepszy taniec i nagranie go 🏆", level: "hard", points: 3, emoji: "🏆" },
];

const EMOJIS = ["🌸", "🎉", "💛", "🍋", "🧡", "🌿", "💃", "🕺", "🎵", "⭐", "🦋", "🌈", "🎯", "🏆", "💎", "🔥", "❤️", "🎸", "🌺", "🍀"];
const LEVEL_LABELS = { easy: "Łatwe", medium: "Średnie", hard: "Trudne" };
const LEVEL_COLORS = { easy: "lime", medium: "orange", hard: "grape" };
const LEVEL_POINTS = { easy: 1, medium: 2, hard: 3 };

function Tasks() {
    const [step, setStep] = useState("select-user"); // select-user | new-user | task | done
    const [guests, setGuests] = useState([]);
    const [currentGuest, setCurrentGuest] = useState(null);
    const [guestName, setGuestName] = useState("");
    const [selectedEmojis, setSelectedEmojis] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState("easy");
    const [currentTask, setCurrentTask] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [ranking, setRanking] = useState([]);
    const [showRanking, setShowRanking] = useState(false);
    const [completedTasks, setCompletedTasks] = useState([]);

    // Pobierz gości z Firebase
    useEffect(() => {
        const unsub = onSnapshot(
            query(collection(db, "wedding_guests"), orderBy("points", "desc")),
            (snap) => {
                const data = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
                setGuests(data);
                setRanking(data);
            }
        );
        return () => unsub();
    }, []);

    // Pobierz wykonane zadania gościa
    useEffect(() => {
        if (!currentGuest) return;
        const unsub = onSnapshot(
            query(collection(db, "wedding_tasks"), where("guestId", "==", currentGuest.id)),
            (snap) => {
                setCompletedTasks(snap.docs.map((d) => d.data().taskId));
            }
        );
        return () => unsub();
    }, [currentGuest]);

    // Losuj zadanie
    const [taskOptions, setTaskOptions] = useState([]);

    const drawTask = () => {
        const available = TASKS.filter(
            (t) => t.level === selectedLevel && !completedTasks.includes(t.id)
        );

        if (available.length === 0) {
            alert(`Wykonałeś wszystkie zadania z poziomu ${LEVEL_LABELS[selectedLevel]}! 🎉`);
            return;
        }

        // Losuj 4 karty
        const shuffled = [...available].sort(() => Math.random() - 0.5);
        const options = shuffled.slice(0, Math.min(4, shuffled.length));
        setTaskOptions(options);
        setCurrentTask(null);
    };

    const selectTask = (task) => {
        setCurrentTask(task);
        setTaskOptions([]);
    };

    // Utwórz nowego gościa
    const createGuest = async () => {
        if (!guestName.trim()) return;
        if (selectedEmojis.length === 0) {
            alert("Wybierz przynajmniej jedno emoji!");
            return;
        }

        const guestData = {
            name: guestName.trim(),
            emojis: selectedEmojis,
            points: 0,
            tasksCompleted: 0,
            createdAt: serverTimestamp(),
        };

        const docRef = await addDoc(collection(db, "wedding_guests"), guestData);
        setCurrentGuest({ id: docRef.id, ...guestData });
        setStep("task");
    };

    // Oznacz zadanie jako wykonane
    const completeTask = async (photoUrl = null) => {
        if (!currentGuest || !currentTask) return;

        // Zapisz wykonane zadanie
        await addDoc(collection(db, "wedding_tasks"), {
            guestId: currentGuest.id,
            guestName: currentGuest.name,
            guestEmojis: currentGuest.emojis,
            taskId: currentTask.id,
            taskText: currentTask.text,
            taskLevel: currentTask.level,
            points: currentTask.points,
            photoUrl: photoUrl,
            completedAt: serverTimestamp(),
        });

        // Jeśli jest zdjęcie — dodaj je też do galerii
        if (photoUrl) {
            await addDoc(collection(db, "photos"), {
                url: photoUrl,
                fileName: `zadanie_${currentTask.id}.jpg`,
                uploadedAt: serverTimestamp(),
                author: `${currentGuest.emojis.join("")} ${currentGuest.name}`,
                category: "Zadania",
                type: "image",
                taskText: currentTask.text,
            });
        }

        // Zaktualizuj punkty gościa
        const { doc, updateDoc, increment } = await import("firebase/firestore");
        await updateDoc(doc(db, "wedding_guests", currentGuest.id), {
            points: increment(currentTask.points),
            tasksCompleted: increment(1),
        });

        setCurrentGuest((prev) => ({
            ...prev,
            points: (prev.points || 0) + currentTask.points,
            tasksCompleted: (prev.tasksCompleted || 0) + 1,
        }));

        setStep("done");
    };

    // Upload zdjęcia do zadania
    const uploadPhoto = async (file) => {
        if (!file) return null;
        setUploading(true);

        const fileName = `tasks/${Date.now()}_${file.name}`;
        const storageRef = ref(storage, fileName);
        const uploadTask = uploadBytesResumable(storageRef, file);

        return new Promise((resolve, reject) => {
            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    const pct = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                    setUploadProgress(pct);
                },
                reject,
                async () => {
                    const url = await getDownloadURL(uploadTask.snapshot.ref);
                    setUploading(false);
                    resolve(url);
                }
            );
        });
    };

    const handlePhotoComplete = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const url = await uploadPhoto(file);
        await completeTask(url);
    };

    const toggleEmoji = (emoji) => {
        setSelectedEmojis((prev) =>
            prev.includes(emoji) ? prev.filter((e) => e !== emoji) : [...prev, emoji]
        );
    };

    // =====================
    // RENDER
    // =====================
    return (
        <div className="tasks-page">

            {/* HEADER */}
            <div className="tasks-header">
                <div className="tasks-header-left">
                    <div className="gal-live-badge">
                        <span className="live-indicator"></span>
                        Zadania weselne
                    </div>
                    <h1 className="tasks-title">
                        Bingo<br /><em>Weselne</em>
                    </h1>
                    <div className="gal-subtitle">Klaudia & Bartłomiej · 15.08.2026</div>
                </div>
                <div className="tasks-header-right">
                    {currentGuest && (
                        <div className="tasks-guest-badge">
                            <div className="tasks-guest-emojis">{currentGuest.emojis.join("")}</div>
                            <div className="tasks-guest-name">{currentGuest.name}</div>
                            <div className="tasks-guest-points">
                                ⭐ {currentGuest.points || 0} pkt
                            </div>
                        </div>
                    )}
                    <button
                        className="tasks-ranking-btn"
                        onClick={() => setShowRanking(!showRanking)}
                    >
                        🏆 Ranking
                    </button>
                </div>
            </div>

            {/* RANKING */}
            {showRanking && (
                <div className="tasks-ranking">
                    <h3 className="tasks-ranking-title">🏆 Ranking gości</h3>
                    {ranking.length === 0 && (
                        <p className="tasks-ranking-empty">Brak wyników — bądź pierwszy! 🎯</p>
                    )}
                    {ranking.map((guest, i) => (
                        <div key={guest.id} className={`ranking-item ${i < 3 ? `ranking-item--${i + 1}` : ""}`}>
                            <div className="ranking-pos">
                                {i === 0 ? "🥇" : i === 1 ? "🥈" : i === 2 ? "🥉" : `${i + 1}.`}
                            </div>
                            <div className="ranking-emojis">{guest.emojis?.join("") || "👤"}</div>
                            <div className="ranking-name">{guest.name}</div>
                            <div className="ranking-score">
                                <span className="ranking-points">⭐ {guest.points || 0} pkt</span>
                                <span className="ranking-tasks">{guest.tasksCompleted || 0} zadań</span>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <div className="tasks-content">

                {/* KROK 1 — WYBIERZ SIEBIE */}
                {step === "select-user" && (
                    <div className="tasks-card">
                        <div className="tasks-card-icon">🎯</div>
                        <h2 className="tasks-card-title">Witaj w Bingo Weselnym!</h2>
                        <p className="tasks-card-sub">Wykonuj zadania i zdobywaj punkty! 🏆</p>

                        {guests.length > 0 && (
                            <>
                                <p className="tasks-section-label">Czy już grałeś? Wybierz siebie:</p>
                                <div className="tasks-guest-list">
                                    {guests.map((guest) => (
                                        <button
                                            key={guest.id}
                                            className="tasks-guest-item"
                                            onClick={() => {
                                                setCurrentGuest(guest);
                                                setStep("task");
                                            }}
                                        >
                                            <span className="tasks-guest-item-emojis">{guest.emojis?.join("") || "👤"}</span>
                                            <span className="tasks-guest-item-name">{guest.name}</span>
                                            <span className="tasks-guest-item-pts">⭐ {guest.points || 0}</span>
                                        </button>
                                    ))}
                                </div>
                                <div className="tasks-divider">lub</div>
                            </>
                        )}

                        <button
                            className="tasks-btn-primary"
                            onClick={() => setStep("new-user")}
                        >
                            ➕ Jestem nowy — dodaj mnie!
                        </button>
                    </div>
                )}

                {/* KROK 2 — NOWY GOŚĆ */}
                {step === "new-user" && (
                    <div className="tasks-card">
                        <div className="tasks-card-icon">👋</div>
                        <h2 className="tasks-card-title">Jak masz na imię?</h2>

                        <input
                            className="tasks-input"
                            type="text"
                            placeholder="Wpisz swoje imię..."
                            value={guestName}
                            onChange={(e) => setGuestName(e.target.value)}
                            maxLength={20}
                            autoFocus
                        />

                        <p className="tasks-section-label">Wybierz swoje emoji (możesz wybrać kilka):</p>
                        <div className="tasks-emoji-grid">
                            {EMOJIS.map((emoji) => (
                                <button
                                    key={emoji}
                                    className={`tasks-emoji-btn ${selectedEmojis.includes(emoji) ? "active" : ""}`}
                                    onClick={() => toggleEmoji(emoji)}
                                >
                                    {emoji}
                                </button>
                            ))}
                        </div>

                        {selectedEmojis.length > 0 && (
                            <div className="tasks-emoji-preview">
                                Twój avatar: {selectedEmojis.join("")} {guestName}
                            </div>
                        )}

                        <div className="tasks-btn-row">
                            <button className="tasks-btn-primary" onClick={createGuest}>
                                ✓ Zaczynamy!
                            </button>
                            <button
                                className="tasks-btn-secondary"
                                onClick={() => setStep("select-user")}
                            >
                                ← Wróć
                            </button>
                        </div>
                    </div>
                )}

                {/* KROK 3 — ZADANIE */}
                {step === "task" && (
                    <div className="tasks-card">
                        <div className="tasks-card-icon">🎯</div>
                        <h2 className="tasks-card-title">Wybierz poziom trudności</h2>

                        <div className="tasks-level-grid">
                            {["easy", "medium", "hard"].map((level) => (
                                <button
                                    key={level}
                                    className={`tasks-level-btn tasks-level-btn--${LEVEL_COLORS[level]} ${selectedLevel === level ? "active" : ""}`}
                                    onClick={() => {
                                        setSelectedLevel(level);
                                        setTaskOptions([]);
                                        setCurrentTask(null);
                                    }}
                                >
          <span className="tasks-level-icon">
            {level === "easy" ? "🟢" : level === "medium" ? "🟡" : "🔴"}
          </span>
                                    <span className="tasks-level-name">{LEVEL_LABELS[level]}</span>
                                    <span className="tasks-level-pts">+{LEVEL_POINTS[level]} pkt</span>
                                </button>
                            ))}
                        </div>

                        <button className="tasks-btn-draw" onClick={drawTask}>
                            🎲 Losuj 4 karty!
                        </button>

                        {/* 4 karty do wyboru */}
                        {taskOptions.length > 0 && !currentTask && (
                            <>
                                <p className="tasks-pick-label">Wybierz kartę aby odkryć zadanie:</p>
                                <div className="tasks-options-grid">
                                    {taskOptions.map((task, index) => (
                                        <div
                                            key={task.id}
                                            className="tasks-flip-card"
                                            onClick={() => selectTask(task)}
                                        >
                                            <div className="tasks-flip-inner">
                                                {/* Przód karty — zakryty */}
                                                <div className="tasks-flip-front">
                                                    <div className="tasks-flip-front-pattern"></div>
                                                    <div className="tasks-flip-front-text">Dotknij aby odkryć</div>
                                                </div>
                                                {/* Tył karty — zadanie */}
                                                <div className={`tasks-flip-back tasks-flip-back--${LEVEL_COLORS[task.level]}`}>
                                                    <div className="tasks-flip-back-icon">{task.emoji}</div>
                                                    <div className="tasks-flip-back-text">{task.text}</div>
                                                    <div className="tasks-flip-back-pts">+{task.points} pkt</div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}

                        {/* Wybrane zadanie */}
                        {currentTask && (
                            <div className={`tasks-task-card tasks-task-card--${LEVEL_COLORS[currentTask.level]}`}>
                                <div className="tasks-task-icon">{currentTask.emoji}</div>
                                <div className="tasks-task-text">{currentTask.text}</div>
                                <div className={`tasks-task-badge tasks-task-badge--${LEVEL_COLORS[currentTask.level]}`}>
                                    {LEVEL_LABELS[currentTask.level]} · +{currentTask.points} pkt
                                </div>

                                <div className="tasks-task-actions">
                                    {uploading ? (
                                        <div className="tasks-upload-progress">
                                            <div className="tasks-progress-bar">
                                                <div className="tasks-progress-fill" style={{ width: `${uploadProgress}%` }}></div>
                                            </div>
                                            <span>{uploadProgress}%</span>
                                        </div>
                                    ) : (
                                        <>
                                            <label className="tasks-btn-photo">
                                                📸 Dokumentuj zdjęciem
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    style={{ display: "none" }}
                                                    onChange={handlePhotoComplete}
                                                />
                                            </label>
                                            <button
                                                className="tasks-btn-done"
                                                onClick={() => completeTask()}
                                            >
                                                ✓ Wykonałem!
                                            </button>
                                        </>
                                    )}
                                </div>

                                <button
                                    className="tasks-btn-back"
                                    onClick={() => {
                                        setCurrentTask(null);
                                        setTaskOptions([]);
                                    }}
                                >
                                    ← Wybierz inne zadanie
                                </button>
                            </div>
                        )}
                    </div>
                )}

                {/* KROK 4 — GRATULACJE */}
                {step === "done" && (
                    <div className="tasks-card tasks-card--success">
                        <div className="tasks-card-icon" style={{ fontSize: "3.5rem" }}>🎉</div>
                        <h2 className="tasks-card-title">Brawo!</h2>
                        <p className="tasks-card-sub">
                            Zadanie wykonane! Zdobyłeś <strong>+{currentTask?.points} pkt</strong>
                        </p>
                        <div className="tasks-total-points">
                            ⭐ Łącznie: {currentGuest?.points || 0} punktów
                        </div>
                        <div className="tasks-btn-row">
                            <button
                                className="tasks-btn-primary"
                                onClick={() => {
                                    setCurrentTask(null);
                                    setStep("task");
                                }}
                            >
                                🎲 Losuj następne zadanie!
                            </button>
                            <button
                                className="tasks-btn-secondary"
                                onClick={() => setShowRanking(true)}
                            >
                                🏆 Zobacz ranking
                            </button>
                        </div>
                    </div>
                )}

            </div>

            <footer className="site-footer">
                <div className="footer-names">Klaudia <span>&</span> Bartłomiej</div>
                <div className="footer-date">15 · 08 · 2026 · Hotel & Restauracja President</div>
                <div className="footer-fruits">🍋 🧡 🍊 💛 🌿</div>
            </footer>

        </div>
    );
}

export default Tasks;